﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconShoe } from "@tabler/icons-react";

export const TallesZapatosIcon = IconShoe;
export const TallesZapatosHelpText = '* Aquí puede ver la lista de talles de calzado.'

export class catTallesZapatos extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TallesZapatos";
        this.def.columns.c_category_id.defaultValue = "TallesZapatos";
        this.Title = "Talles de Zapatos";
        this.Icon = TallesZapatosIcon;
        this.HelpText = TallesZapatosHelpText;
    }
}